'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import serialize from 'serialize-javascript'

var GoogleTagManager = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(GoogleTagManager, _React$Component);

  function GoogleTagManager() {
    (0, _classCallCheck3.default)(this, GoogleTagManager);
    return (0, _possibleConstructorReturn3.default)(this, (GoogleTagManager.__proto__ || (0, _getPrototypeOf2.default)(GoogleTagManager)).apply(this, arguments));
  }

  (0, _createClass3.default)(GoogleTagManager, [{
    key: 'renderDataLayerAssignment',
    value: function renderDataLayerAssignment() {
      // const events = this.props.dataLayer.map(serialize).join(', ')
      // return `window.dataLayer=[${events}];`
      return 'window.rawData=[];';
    }
  }, {
    key: 'render',
    value: function render() {
      if (__CLIENT__) return null;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          script: [{
            type: 'text/javascript',
            innerHTML: this.renderDataLayerAssignment()
          }, {
            type: 'text/javascript',
            innerHTML: '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n              new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n              j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n              \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n              })(window,document,\'script\',\'dataLayer\',\'' + this.props.containerId + '\');'
          }]
        }),
        _react2.default.createElement(
          'noscript',
          null,
          _react2.default.createElement('iframe', {
            src: 'https://www.googletagmanager.com/ns.html?id=' + this.props.containerId,
            height: '0',
            width: '0',
            style: { display: 'none', visibility: 'hidden' }
          })
        )
      );
    }
  }]);
  return GoogleTagManager;
}(_react2.default.Component), _class.propTypes = {
  containerId: _react.PropTypes.string.isRequired,
  dataLayer: _react.PropTypes.array
}, _class.defaultProps = {
  dataLayer: []
}, _temp);
exports.default = GoogleTagManager;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/GoogleTagManager/index.js
// module id = 586
// module chunks = 0